var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotSell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76244 14.2376L0 16L1.41421 17.4142L17.4142 1.41421L16 0L13.293 2.70703H12.707V3.29297L9.70703 6.29297V3.70703H11.707L8.70703 0.707031L5.70703 3.70703H7.70703V7.70703H8.29297L6.29297 9.70703H4.70703V1.70703C4.70703 1.15503 4.26003 0.707031 3.70703 0.707031H0.707031V2.70703H2.70703V10.707C2.70703 11.259 3.15403 11.707 3.70703 11.707H4.29297L3.23756 12.7624C2.51007 12.9374 1.93744 13.5101 1.76244 14.2376ZM13.707 11.707H9.82858L11.8286 9.70703H12.953L13.4026 8.13305L16.3152 5.22039L14.669 10.982C14.546 11.411 14.153 11.707 13.707 11.707ZM15.707 14.707C15.707 15.8116 14.8116 16.707 13.707 16.707C12.6025 16.707 11.707 15.8116 11.707 14.707C11.707 13.6025 12.6025 12.707 13.707 12.707C14.8116 12.707 15.707 13.6025 15.707 14.707Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSell);
export default __webpack_public_path__ + "static/media/not-sell.3e419e25cbd1b6afa5aae7790ded258c.svg";
export { ForwardRef as ReactComponent };